<template>
  <!-- eslint-disable max-len -->
  <div :class="{ 'form-group': !inline, inline }" style="margin-left: 5px;">
    <div class="form-check my-2">
      <input
        :value="value"
        :checked="value"
        @change="onChange"
        @blur="onBlur"
        type="checkbox"
        class="form-check-input"
        :id="_uid"
        :disabled="disabled"
        v-focus="autofocus">
      <label :for="_uid" class="form-check-label"><slot></slot></label>
    </div>
    <template v-if="validator && validator.$error">
      <p class="error-msg" v-if="required && !validator.required">{{ $slots.default[0].text }} is required</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    inline: { type: Boolean },
    required: { type: Boolean },
    validator: { type: Object },
    value: { type: Boolean }
  },
  methods: {
    onBlur($event) {
      if (this.validator) this.validator.$touch();
      this.$emit('blur', $event);
    },
    onChange($event) {
      this.$emit('input', $event.target.checked);
      this.$emit('change', $event);
    }
  }
};
</script>

<style lang="scss" scoped>
.inline {
  display: inline-block;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/CheckboxInput.vue